import Chart from 'chart.js/auto'
import {OA_TYPES, OA_TYPES_BG_COLORS} from './config';

export default class StackedBarChartTopics {

  constructor(elementId, data) {
    this.elementId = elementId;
    this.data = data;
    this.initYearSelector();
    this.initDatasets();
    
    this.addGraph();
  }

  initDatasets() {
    this.datasets = []

    for (const oatype of OA_TYPES) {
      const dataset = {
        label: oatype,
        data: [],
        backgroundColor: OA_TYPES_BG_COLORS[oatype],
      }

      for (const topic of this.getTopics()) {
        dataset.data.push(
          this.getCountByTopicAndOaType(topic, oatype)
        )
      }

      this.datasets.push(dataset)
    }
  }

  initYearSelector() {
    this.yearSelector = document.getElementById('pbt-year-selector')
    this.selectedYear = this.yearSelector.value

    this.yearSelector.addEventListener('change', (event) => {
      this.selectedYear = event.target.value
      this.initDatasets()

      // Update chart
      this.chart.data.datasets = this.datasets
      this.chart.update()
    })
  }


  getTopics() {
    const selectedData = this.data[this.selectedYear]["oa_topic_aggregation"]
    const topics = selectedData.map((elem) => elem["_id"]["topic"])
    const uniqueTopics = [...new Set(topics)]

    return uniqueTopics.sort()
  }

  getCountByTopicAndOaType(topic, type) {
    const seletedData = this.data[this.selectedYear]["oa_topic_aggregation"]
    try {
      return seletedData.find((elem) => elem["_id"]["topic"] === topic && elem["_id"]["oatype"] === type).count
    } catch (error) {
      return 0
    }
  }

  addGraph() {
    const data = {
      labels: this.getTopics(),
      datasets: this.datasets
    };

    this.chart = new Chart(
      document.getElementById(this.elementId),
        {
          type: 'bar',
          data: data,
          options: {
            scales: {
              x: {
                stacked: true
              },
              y: {
                stacked: true
              }
            }
          }
        }
    );
  }
}
